import { Link } from '@tanstack/react-router';
import { FormattedMessage } from 'react-intl';

import { useAuthenticatedUser } from '../providers/AuthenticatedUserProvider';
import { Breadcrumb } from './Breadcrumb';
import { Dropdown } from './DropDown';
import { SheetMenu } from './SheetMenu';

interface NavbarProps {
  isSuperUser: boolean;
}

export const Navbar = ({ isSuperUser }: NavbarProps): JSX.Element => {
  const { user } = useAuthenticatedUser();

  return (
    <header
      className={`sticky top-0 z-10 w-full ${isSuperUser ? 'bg-red-500/95' : 'bg-background/95'} shadow backdrop-blur supports-[backdrop-filter]:${isSuperUser ? 'bg-red-500/60' : 'bg-background/60'} dark:shadow-secondary`}
    >
      <div className="mx-4 sm:mx-8 flex h-14 items-center gap-2">
        <div className="flex items-center space-x-4 lg:space-x-0">
          <SheetMenu />
          <h1 className="sm:block hidden">
            <Breadcrumb />
          </h1>
        </div>
        <div className="flex flex-1 items-center space-x-2 justify-end gap-4">
          <p className="text-sm text-muted-foreground hover:underline">
            <Link to="/my-profile">
              <FormattedMessage
                id="global.menu.welcome"
                values={{ username: user.email }}
              />
            </Link>
          </p>
          <Dropdown />
        </div>
      </div>
    </header>
  );
};
